module.exports = __webpack_public_path__ + "img/levelup_platinum_completed.0fd0fae7.svg";